export class Preloader {
  static VALUE_MAX = 100;
  static MILESTONES = [22, 89, 100];
  static PAUSE_MS = 500;
  static STEP_MS = 25;
  static STORAGE_KEY = 'preloaderPlayed';

  constructor() {
    this.$progress = document.querySelector('[data-preloader="progress"]');
    this.$value = document.querySelector('[data-preloader="value"]');

    this.value = 0;
    this._rafId = null;
    this._pauseTimeout = null;
    this._milestoneIndex = 0;

    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
  }

  _updateDOM() {
    const v = Math.round(this.value);
    if (this.$progress) this.$progress.style.width = `${v}%`;
    if (this.$value) this.$value.textContent = v;
  }

  _tick() {
    const target = Preloader.MILESTONES[this._milestoneIndex];
    const step = (target - this.value) * 0.15;
    if (Math.abs(step) < 0.05) {
      this.value = target;
      this._updateDOM();
      if (target >= Preloader.VALUE_MAX) {
        // Помечаем в sessionStorage, что прелоадер уже отыграл
        try {
          sessionStorage.setItem(Preloader.STORAGE_KEY, '1');
        } catch (_) {}

        document.documentElement.classList.add('is-preloader-load');
        this.stop();
        return;
      }
      this._milestoneIndex++;
      this._pauseTimeout = setTimeout(() => {
        this._pauseTimeout = null;
        this._rafId = requestAnimationFrame(() => this._tick());
      }, Preloader.PAUSE_MS);
      return;
    }
    this.value = Math.min(this.value + step, target);
    this._updateDOM();
    this._rafId = requestAnimationFrame(() => this._tick());
  }

  start() {
    this.stop();
    document.documentElement.classList.remove('is-preloader-load');
    this.value = 0;
    this._milestoneIndex = 0;
    this._updateDOM();
    this._rafId = requestAnimationFrame(() => this._tick());
  }

  stop() {
    if (this._rafId != null) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }
    if (this._pauseTimeout != null) {
      clearTimeout(this._pauseTimeout);
      this._pauseTimeout = null;
    }
  }

  // =============================================================================
  // Lifecycle
  // =============================================================================
  static init() {
    // Если прелоадер уже отыграл в этой сессии — больше не показываем его
    try {
      if (sessionStorage.getItem(Preloader.STORAGE_KEY) === '1') {
        document.documentElement.classList.add('is-preloader-load');
        return;
      }
    } catch (_) {
      // Если sessionStorage недоступен, просто продолжаем обычную анимацию
    }

    this.preloader = new Preloader();
    this.preloader.start();
  }
}
